import MoneyLenderSubmitBody from 'types/MoneyLenderSubmitBody';
import { http } from '../http';
import type { Client } from '../types/Client';

export type Filter = {
  filterField: string;
  filterOperator: 'like' | 'equal';
  value: string;
};

export type ClientListResponse = {
  total: number;
  syncedOnUtc: string;
  isExportAvailable: boolean;
  clients: Client[];
};

export const getClientsList = async (
  isLabeled: boolean,
  commercialRelation: string | undefined,
  skip: number,
  take: number,
  filters: Filter[]
): Promise<ClientListResponse> => {
  return isLabeled
    ? getLabeledClientsList(commercialRelation, skip, take, filters)
    : getGenericClientsList(skip, take, filters);
};

const getLabeledClientsList = async (
  commercialRelation: string | undefined,
  skip: number,
  take: number,
  filters: Filter[]
): Promise<ClientListResponse> => {
  const mappedFilters = filters
    .map((filter) => `&filter=${filter.filterField} ${filter.filterOperator} ${filter.value}`)
    .join('');

  const response = await http.get(
    `/api/clients/commercialrelation/${commercialRelation}?skip=${skip}&take=${take}${mappedFilters}`
  );

  return response.data;
};

const getGenericClientsList = async (
  skip: number,
  take: number,
  filters: Filter[]
): Promise<ClientListResponse> => {
  const mappedFilters = filters
    .map((filter) => `&filter=${filter.filterField} ${filter.filterOperator} ${filter.value}`)
    .join('');

  const response = await http.get(`/api/clients?skip=${skip}&take=${take}${mappedFilters}`);

  return response.data;
};

export type MoneylenderResponse = {
  commercialLabel: string;
  moneylenderName: string;
};

export const getMoneylenders = async (): Promise<MoneylenderResponse[]> => {
  const response = await http.get('/api/clients/moneylenders');

  return response.data;
};

export const syncClientList = async () => {
  await http.post('/api/clients/sync', null);
};

export type RelatedMoneylenderResponse = {
  commercialRelation: string;
  displayName: string;
};

export const getRelatedMoneylenders = async (): Promise<RelatedMoneylenderResponse[]> => {
  const response = await http.get('/api/v1/moneylenders');

  return response.data;
};

export async function submitCreateClient(formData: MoneyLenderSubmitBody) {
  const response = await http.post('/api/v1/clients/transfer', formData);
  return response;
}
